import 'es6-promise/auto'
import Vue from 'vue' //引入vue
import Vuex from 'vuex' //引入vuex
import axios from 'axios'
import util from 'util'
import $ from 'jquery'
Vue.use(Vuex); //使用 vuex

export default new Vuex.Store({
    state: {
        // 初始化状态
        // currentUser: null,
        // isLogin: false,
        // token: "",
        // expertId: null,
        // dirID:null

    },
    mutations: {
        // 处理状态
        // userStatus: (state, user) => {
        //     if (user) {
        //         state.currentUser = user;
        //         state.isLogin = true;

        //     } else if (user == null) {
        //         //sessionStorage.setItem("expertId",null);
        //     }
        // },
        // idStatus: (state, id) => {
        //     if (id) {
        //         state.expertId = id;
        //     } else if (id == null) {
        //         sessionStorage.setItem("expertId", null);
        //     }
        // },
        // userStatus(state,payload){
        //     state.expertId = payload
        // },
        // idStatus(state,payload){
        //     state.dirID = payload
        // }

    },
    actions: {
        //处理列表项
        // async EXPERID(context){
        //   console.log(context);
        //   // var expertId = localStorage.getItem("expertId");
        //   await axios.post('/api/Bw/GetliefDir?expertId=2').then((res =>{
        //     var obj = res.data.Data
        //     // obj.forEach(e => {
        //     //   // (function (i) {
        //     //     context.commit('userStatus',e.ExpertId);
        //     //     context.commit('idStatus',e.Id)
        //     //   // })(i)
        //     // })
        //     var arr = []
        //     for (var i = 0; i < obj.length; i++) {
        //       arr.push({"dirID": obj[i].Id, "expertId": obj[i].ExpertId})
        //     }
        //     context.commit('userStatus',arr);
        //     context.commit('idStatus',arr)
        //   }))
        // }
    },
    getters: {
        // 提交改变后的状态
        // expertId:function(state){
        //     return state.expertId
        // },
        // dirID:function(state){
        //   return state.dirID
        // }
    },
})



// WEBPACK FOOTER //
// ./src/store/index.js